"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionRecurrenceInterval = void 0;
var SubscriptionRecurrenceInterval;
(function (SubscriptionRecurrenceInterval) {
    SubscriptionRecurrenceInterval["Weekly"] = "Weekly";
    SubscriptionRecurrenceInterval["BiWeekly"] = "BiWeekly";
    SubscriptionRecurrenceInterval["Monthly"] = "Monthly";
    SubscriptionRecurrenceInterval["Quarterly"] = "Quarterly";
    SubscriptionRecurrenceInterval["Yearly"] = "Yearly";
})(SubscriptionRecurrenceInterval || (exports.SubscriptionRecurrenceInterval = SubscriptionRecurrenceInterval = {}));
